import Experience   from '../../Experience.js'
import * as THREE from 'three'

export default class Descriptions {
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.loader.items

        this.currentGroup = new THREE.Group()
        this.currentGroup.rotation.order = "YXZ"
        this.nowShowing = 0

        this.create()
    }

    create()
    {
        // Project 01
        this.project01 = new THREE.Group()

        const pic01 = new THREE.Mesh(
            new THREE.PlaneGeometry(16 * 1.2, 9 * 1.2),
            new THREE.MeshBasicMaterial({
                map: this.resources.test_01,
                toneMapped: false
            })
        )
        pic01.position.set(-9, 5.2, -21)

        const text01 = new THREE.Mesh(
            new THREE.PlaneGeometry(18, 23),
            new THREE.MeshBasicMaterial({
                map: this.resources.desc_01,
                toneMapped: false
            })
        )
        text01.position.set(-29, -0.9, -21)
        this.project01.add(pic01)
        this.project01.add(text01)

        // Project 02
        this.project02 = new THREE.Group()

        const pic02 = new THREE.Mesh(
            new THREE.PlaneGeometry(16 * 1.2, 9 * 1.2),
            new THREE.MeshBasicMaterial({
                map: this.resources.marble_desc_pic,
                toneMapped: false
            })
        )
        pic02.position.set(-9, 5.2, -21)

        const text02 = new THREE.Mesh(
            new THREE.PlaneGeometry(18, 23),
            new THREE.MeshBasicMaterial({
                map: this.resources.marble_desc,
                toneMapped: false
            })
        )
        text02.position.set(-29, -0.9, -21)
        this.project02.add(pic02)
        this.project02.add(text02)

        // About Me
        this.aboutMe = new THREE.Group()

        const title = this.resources.aboutMeTitle
        title.position.set(-20, 13, -20)
        title.rotation.x = Math.PI / 32
        this.aboutMe.add(title)

        const workTitle = this.resources.workTitle
        workTitle.position.set(-30, -3.5, -20)
        workTitle.rotation.x = Math.PI / 32
        this.aboutMe.add(workTitle)

        const skillsTitle = this.resources.skillsTitle
        skillsTitle.position.set(-10, -3.5, -20)
        skillsTitle.rotation.x = Math.PI / 32
        this.aboutMe.add(skillsTitle)

        const summary = new THREE.Mesh(
            new THREE.PlaneGeometry(16 * 2.5, 4.5 * 2.5),
            new THREE.MeshBasicMaterial({
                map: this.resources.aboutMeDesc,
                toneMapped: false
            })
        )
        summary.position.set(-20, 5.2, -21)

        const workExp = new THREE.Mesh(
            new THREE.PlaneGeometry(8 * 2.5, 7.5),
            new THREE.MeshBasicMaterial({
                map: this.resources.workExp,
                toneMapped: false
            })
        )
        workExp.position.set(-30, -10, -21)

        const skills = new THREE.Mesh(
            new THREE.PlaneGeometry(8 * 2, 4.5),
            new THREE.MeshBasicMaterial({
                map: this.resources.skills,
                toneMapped: false,
                transparent: true
            })
        )
        skills.position.set(-10, -8, -21)

        this.aboutMe.add(summary)
        this.aboutMe.add(workExp)
        this.aboutMe.add(skills)

        // Buttons
        this.createPlayButton()
        this.createBackButton()
    }

    createPlayButton()
    {
        // Sources
        const geometry = new THREE.PlaneGeometry(16, 3)
        const whtPlayMaterial = new THREE.MeshBasicMaterial({
            map: this.resources.whtPlayTexture,
            transparent: true
        })
        
        this.playButton = new THREE.Mesh(
            geometry,
            whtPlayMaterial
        )
        this.playButton.position.set(-9, -4.6, -21)
    }

    createBackButton()
    {
        // Sources
        const geometry = new THREE.PlaneGeometry(16, 3)
        const whtBackMaterial = new THREE.MeshBasicMaterial({
            map: this.resources.whtBackTexture,
            transparent: true
        })
        
        this.backButton = new THREE.Mesh(
            geometry,
            whtBackMaterial
        )
    }

    show(texture)
    {
        if(texture === this.resources.test_01)
        {
            this.currentGroup.add(this.project01)
            this.currentGroup.add(this.playButton)
            this.currentGroup.add(this.backButton)
            this.backButton.position.set(-9, -8, -21)

            // Left
            this.currentGroup.position.set(-40, 1.5, 3)
            this.currentGroup.rotation.y = Math.PI * 9/16
            this.currentGroup.rotation.x = Math.PI / 32

            this.scene.add(this.currentGroup)
            this.nowShowing = 1
        }

        else if(texture === this.resources.marble_desc_pic)
        {
            this.currentGroup.add(this.project02)
            this.currentGroup.add(this.playButton)
            this.currentGroup.add(this.backButton)
            this.backButton.position.set(-9, -8, -21)

            // Left
            this.currentGroup.position.set(-40, 1.5, 3)
            this.currentGroup.rotation.y = Math.PI * 9/16
            this.currentGroup.rotation.x = Math.PI / 32

            this.scene.add(this.currentGroup)
            this.nowShowing = 2
        }

        else if(texture === this.resources.aboutMeThumbnail)
        {
            this.currentGroup.add(this.aboutMe)
            this.currentGroup.add(this.backButton)
            this.backButton.position.set(-10, -16, -21)

            // Left
            this.currentGroup.position.set(-40, 1.5, 3)
            this.currentGroup.rotation.y = Math.PI * 9/16
            this.currentGroup.rotation.x = Math.PI / 32

            this.scene.add(this.currentGroup)
            this.nowShowing = 3
        }
    }

    hide()
    {
        this.scene.remove(this.currentGroup)

        const initialLength = this.currentGroup.children.length
        for(let i = 0; i < initialLength; i++)
        {
            this.currentGroup.remove(this.currentGroup.children[0])
        }

        this.nowShowing = 0
    }
}